"use strict";
/* eslint-disable */
/**
 * This file was automatically generated by scripts/manifest/deserialize-ts.mustache.
 * DO NOT MODIFY IT BY HAND. Instead, modify scripts/manifest/deserialize-ts.mustache,
 * and run node ./scripts/manifest/generateFormatTypes.js to regenerate this file.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeMetaManifest = void 0;
var _1 = require(".");
var semver_1 = require("semver");
var js_yaml_1 = __importDefault(require("js-yaml"));
var tracing_js_1 = require("@web3api/tracing-js");
exports.deserializeMetaManifest = tracing_js_1.Tracer.traceFunc("core: deserializeMetaManifest", function (manifest, options) {
    var anyMetaManifest = js_yaml_1.default.safeLoad(manifest);
    if (!anyMetaManifest) {
        throw Error("Unable to parse MetaManifest: " + manifest);
    }
    if (!options || !options.noValidate) {
        _1.validateMetaManifest(anyMetaManifest, options === null || options === void 0 ? void 0 : options.extSchema);
    }
    anyMetaManifest.__type = "MetaManifest";
    var versionCompare = semver_1.compare(anyMetaManifest.format, _1.latestMetaManifestFormat);
    if (versionCompare === -1) {
        // Upgrade
        return _1.migrateMetaManifest(anyMetaManifest, _1.latestMetaManifestFormat);
    }
    else if (versionCompare === 1) {
        // Downgrade
        throw Error("Cannot downgrade Web3API version " + anyMetaManifest.format + ", please upgrade your Web3ApiClient package.");
    }
    else {
        // Latest
        return anyMetaManifest;
    }
});
//# sourceMappingURL=deserialize.js.map